import { BOOTH_VAULT_SIGNAL_SEED_DESCRIPTIONS } from '@terra/shared-contracts-booth';

const boothDescriptionOrder = (): Map<string, number> =>
  new Map(
    BOOTH_VAULT_SIGNAL_SEED_DESCRIPTIONS.map((description, index) => [
      description,
      index,
    ]),
  );

export const orderSignalsForBoothVault = <
  T extends { description?: string | null },
>(
  signals: T[],
): T[] => {
  const order = boothDescriptionOrder();
  return [...signals].sort((left, right) => {
    const leftOrder =
      order.get(left.description ?? '') ?? Number.MAX_SAFE_INTEGER;
    const rightOrder =
      order.get(right.description ?? '') ?? Number.MAX_SAFE_INTEGER;
    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }
    return 0;
  });
};

export const boothVaultAttackSignalIndex = <
  T extends { description?: string | null },
>(
  signals: T[],
): number => {
  const firstDescription = BOOTH_VAULT_SIGNAL_SEED_DESCRIPTIONS[0];
  const index = signals.findIndex(
    (signal) => signal.description === firstDescription,
  );
  return index >= 0 ? index : 0;
};
